export default "__VITE_ASSET__CUaHiHye__"